import error from "../assets/cancel.png";
import logo from '../assets/servimaxlogo.jpg'

const Error = () => {
    return (

        <div className="container d-flex justify-content-center align-items-center">

            <div className="row">
                <div className="col-md-6 mx-auto mt-5">
                    <div className="payment">
                        <div className="payment_header">
                            <div className="check"><i className="fa fa-check" aria-hidden="true"></i></div>
                        </div>
                        <div className="content">
                            <img src={logo} alt="" width="150"/>
                            <h1>No permitido</h1>
                            <img src={error} alt=""/>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )

}
export default Error;